import { Coord } from '@everyboard/games';
import { Move } from '@everyboard/games';
import { SuperRules } from '@everyboard/games';
import { EmptyRulesConfig, RulesConfig } from '@everyboard/games';
import { GameStateWithTable } from '@everyboard/games';

import { RectangularGameComponent } from '../rectangular-game-component/RectangularGameComponent';

import { ModeConfig } from './ModeConfig';

export abstract class ParallelogramGameComponent<R extends SuperRules<M, S, C, L>,
                                                 M extends Move,
                                                 S extends GameStateWithTable<P>,
                                                 P extends NonNullable<unknown>,
                                                 C extends RulesConfig = EmptyRulesConfig,
                                                 L = void>
    extends RectangularGameComponent<R, M, S, P, C, L>
{
    public constructor(urlName: string) {
        super(urlName);
    }

    public getParallelogramCoords(mode: ModeConfig): Coord[] {
        const parallelogramHeight: number = mode.parallelogramHeight;
        const parallelogramWidth: number = parallelogramHeight * mode.horizontalWidthRatio;
        const parallelogramOffset: number = parallelogramHeight * mode.offsetRatio;
        const x1: number = parallelogramWidth;
        const y1: number = 0;
        const x2: number = parallelogramWidth - parallelogramOffset;
        const y2: number = parallelogramHeight;
        const x3: number = - parallelogramOffset;
        const y3: number = parallelogramHeight;
        return [
            new Coord(0, 0),
            new Coord(x1, y1),
            new Coord(x2, y2),
            new Coord(x3, y3),
        ];
    }
    /**
     * @param x the x coord on the state of the piece to draw
     * @param y the y coord on the state of the piece to draw
     * @param z the z coord on the state of the piece to draw
     * @param mode the mode in which the component is to be drawn
     * @returns the coord(x, y) of the upper left parallelogram to draw on the SVG;
     */
    protected getCoordTranslation(x: number, y: number, z: number, mode: ModeConfig): Coord {
        const spaceHeight: number = mode.parallelogramHeight;
        const spaceWidth: number = spaceHeight * mode.horizontalWidthRatio;
        const spaceOffset: number = mode.offsetRatio * spaceHeight;
        const numberOfOffset: number = this.state().getHeight()-y;
        const xBase: number = (x * spaceWidth) + (numberOfOffset * spaceOffset);
        const yBase: number = (y * spaceHeight) - (mode.pieceHeightRatio * spaceHeight * z);
        return new Coord(xBase, yBase);
    }
}
